<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4 nowrap">
  <span class="titulo">
    <span class="cursor-pointer" (click)="volver()">Categorías</span>
    >
    {{ title }}
  </span>
</h2>

<!-- Preview de botonera flotante (esquina, colapsable; sin cliente → placeholders genéricos). -->
@if (formulario) {
  <div class="preview-flotante" [class.colapsado]="previewColapsado">
    <button
      type="button"
      class="preview-toggle"
      (click)="previewColapsado = !previewColapsado"
    >
      <mat-icon>{{ previewColapsado ? 'visibility' : 'close' }}</mat-icon>
      <span>{{ previewColapsado ? 'Ver preview' : 'Preview' }}</span>
    </button>
    @if (!previewColapsado) {
      <app-provisionador-preview
        [vm]="previewVm"
        [soloBotonera]="true"
      ></app-provisionador-preview>
    }
  </div>
}

<div class="table-container mat-elevation-z8 p-2">
  @if (formulario) {
    <form
      id="form"
      [formGroup]="formulario"
      (ngSubmit)="enviar()"
      autocomplete="off"
    >
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input
          matInput
          placeholder="Nombre"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Variante</mat-label>
        <input matInput placeholder="Variante" formControlName="variante" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Plantilla de botonera (app nativa)</mat-label>
        <mat-select formControlName="inicioTemplate">
          <mat-option [value]="null">— Usar la del cliente —</mat-option>
          @for (o of botoneraOpciones; track o.id) {
            <mat-option [value]="o.id">{{ o.label }}</mat-option>
          }
        </mat-select>
        <mat-hint>Plantilla del botón nativo para esta categoría.</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>nombre del template</mat-label>
        <input
          matInput
          placeholder="Nombre para el template"
          formControlName="nombreTemplate"
        />
      </mat-form-field>
      <div class="mb-3 row gap-15px">
        <mat-form-field style="width: 100%">
          <mat-label>Color de la Alerta</mat-label>
          <input matInput readonly formControlName="color" />
          <ngx-colors
            matSuffix
            ngx-colors-trigger
            formControlName="color"
            (change)="onColorChange($event, 'color')"
          />
        </mat-form-field>
        <div
          class="color-container"
          [style.background]="formulario.get('color')?.value"
          [style.color]="helper.invertColor(formulario.get('color')?.value)"
        >
          ALERTA
        </div>
      </div>
      <mat-form-field>
        <mat-label>Prioridad</mat-label>
        <input
          matInput
          type="number"
          placeholder="Prioridad, número mas bajo es mayor prioridad"
          formControlName="prioridad"
        />
      </mat-form-field>
      <!-- Botones Principales => Primer Pantalla -->
      <ng-select
        [items]="botones"
        [(ngModel)]="idsPrincipalesSelecionados"
        [ngModelOptions]="{ standalone: true }"
        [hideSelected]="true"
        placeholder="Botones Principales"
        [multiple]="true"
        [searchFn]="searchBoton"
        [closeOnSelect]="false"
        bindValue="_id"
        bindLabel="nombre"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
      </ng-select>
      <!-- Orden Principales -->
      @if (idsPrincipalesSelecionados.length) {
        <div
          cdkDropList
          class="list"
          (cdkDropListDropped)="dropPrincipales($event)"
        >
          @for (id of idsPrincipalesSelecionados; track id; let i = $index) {
            <div class="box" cdkDrag>
              <div class="row fill gap-12px">
                <div class="custom-placeholder" *cdkDragPlaceholder></div>
                <mat-icon
                  cdkDragHandle
                  color="accent"
                  [ngClass]="{ 'cursor-move': true }"
                  >drag_indicator</mat-icon
                >
                <span>{{ i + 1 }}</span>
                <span>{{ btnName(id) || id }}</span>
              </div>
            </div>
          }
        </div>
      }
      <!-- Botones Secundarios => Segunda Pantalla -->
      <ng-select
        [items]="botones"
        [(ngModel)]="idsSecundariosSelecionados"
        [ngModelOptions]="{ standalone: true }"
        [hideSelected]="true"
        placeholder="Botones Secundarios"
        [multiple]="true"
        [searchFn]="searchBoton"
        [closeOnSelect]="false"
        bindValue="_id"
        bindLabel="nombre"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
      </ng-select>
      <!-- Orden Secundarios -->
      @if (idsSecundariosSelecionados.length) {
        <div
          cdkDropList
          class="list"
          (cdkDropListDropped)="dropSecundarios($event)"
        >
          @for (id of idsSecundariosSelecionados; track id; let i = $index) {
            <div class="box" cdkDrag>
              <div class="row fill gap-12px">
                <div class="custom-placeholder" *cdkDragPlaceholder></div>
                <mat-icon
                  cdkDragHandle
                  color="accent"
                  [ngClass]="{ 'cursor-move': true }"
                  >drag_indicator</mat-icon
                >
                <span>{{ i + 1 }}</span>
                <span>{{ btnName(id) || id }}</span>
              </div>
            </div>
          }
        </div>
      }
      <!-- Otros Botones => Tercer Pantalla -->
      <ng-select
        [items]="botones"
        [(ngModel)]="idsOtrosSelecionados"
        [ngModelOptions]="{ standalone: true }"
        [hideSelected]="true"
        placeholder="Otros Botones"
        [multiple]="true"
        [searchFn]="searchBoton"
        [closeOnSelect]="false"
        bindValue="_id"
        bindLabel="nombre"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
      </ng-select>
      <!-- Orden Otros -->
      @if (idsOtrosSelecionados.length) {
        <div cdkDropList class="list" (cdkDropListDropped)="dropOtros($event)">
          @for (id of idsOtrosSelecionados; track id; let i = $index) {
            <div class="box" cdkDrag>
              <div class="row fill gap-12px">
                <div class="custom-placeholder" *cdkDragPlaceholder></div>
                <mat-icon
                  cdkDragHandle
                  color="accent"
                  [ngClass]="{ 'cursor-move': true }"
                  >drag_indicator</mat-icon
                >
                <span>{{ i + 1 }}</span>
                <span>{{ btnName(id) || id }}</span>
              </div>
            </div>
          }
        </div>
      }
      <!-- 3er Boton de Control RF -->
      <!-- [(ngModel)]="idsOtrosSelecionados"
            [ngModelOptions]="{ standalone: true }" -->
      <ng-select
        [items]="botones"
        formControlName="idBotonAlertaControl"
        [hideSelected]="true"
        placeholder="Tercer Botón de Control genera Alerta"
        [searchFn]="searchBoton"
        [multiple]="false"
        [closeOnSelect]="true"
        bindValue="_id"
        bindLabel="nombre"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <span>
            {{ item.nombre }}
            {{ item.variante ? "(" + item.variante + ")" : "" }}
          </span>
        </ng-template>
      </ng-select>
      <!-- Botón 1 -->
      <div class="row-center" style="gap: 8px">
        <section class="layout">
          <div>
            <span> Botón 1 (A): </span>
          </div>
          <div class="grow1">
            <mat-form-field>
              <mat-label>Acción </mat-label>
              <mat-select
                [value]="boton1"
                (selectionChange)="updateBoton(1, $event.value)"
              >
                @for (a of acciones; track a) {
                  <mat-option [value]="a">{{ a }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (boton1 === "Alerta") {
            <div class="grow1">
              <ng-select
                placeholder="Alerta"
                formControlName="boton1"
                [appendTo]="appendTo"
              >
                @for (b of botones; track b._id) {
                  <ng-option [value]="b._id"
                    >{{ b.nombre }} ({{ b.variante }})</ng-option
                  >
                }
              </ng-select>
            </div>
          }
        </section>
      </div>
      <!-- Botón 2 -->
      <div class="row-center" style="gap: 8px">
        <section class="layout">
          <div><span>Botón 2 (B):</span></div>
          <div class="grow1">
            <mat-form-field>
              <mat-label>Acción </mat-label>
              <mat-select
                [value]="boton2"
                (selectionChange)="updateBoton(2, $event.value)"
              >
                @for (a of acciones; track a) {
                  <mat-option [value]="a">{{ a }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (boton2 === "Alerta") {
            <div class="grow1">
              <ng-select
                placeholder="Alerta"
                formControlName="boton2"
                [appendTo]="appendTo"
              >
                @for (b of botones; track b._id) {
                  <ng-option [value]="b._id"
                    >{{ b.nombre }} ({{ b.variante }})</ng-option
                  >
                }
              </ng-select>
            </div>
          }
        </section>
      </div>
      <!-- Botón 3 -->
      <div class="row-center" style="gap: 8px">
        <section class="layout">
          <div><span>Botón 3 (C):</span></div>
          <div class="grow1">
            <mat-form-field>
              <mat-label>Acción </mat-label>
              <mat-select
                [value]="boton1"
                (selectionChange)="updateBoton(3, $event.value)"
              >
                @for (a of acciones; track a) {
                  <mat-option [value]="a">{{ a }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (boton3 === "Alerta") {
            <div class="grow1">
              <ng-select
                placeholder="Alerta"
                formControlName="boton3"
                [appendTo]="appendTo"
              >
                @for (b of botones; track b._id) {
                  <ng-option [value]="b._id"
                    >{{ b.nombre }} ({{ b.variante }})</ng-option
                  >
                }
              </ng-select>
            </div>
          }
        </section>
      </div>
      <div class="mb-2">
        <mat-checkbox formControlName="twitter">Mostrar Twitter</mat-checkbox>
      </div>
    </form>
  }

  <div class="row justify-end gap-10px">
    <button
      class="botonSpinner"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!formulario?.valid || loading"
      form="form"
    >
      <div
        class="loadSpinnerButton"
        [style.display]="loading ? 'flex' : 'none'"
      >
        <mat-spinner
          class="mx-2"
          [diameter]="25"
          mode="indeterminate"
          color="warn"
        />
      </div>
      <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
    </button>

    <button mat-raised-button type="button" (click)="volver()">Volver</button>
  </div>
</div>
